import { render } from "./OOBLetter.vue?vue&type=template&id=b169e548"
import script from "./OOBLetter.vue?vue&type=script&lang=js"
export * from "./OOBLetter.vue?vue&type=script&lang=js"

import "./OOBLetter.vue?vue&type=style&index=0&id=b169e548&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__